import React from 'react';
import { get, isString } from 'lodash';
import queryString from 'query-string';
import { camelCase } from 'change-case';
import { useTranslation, Trans } from 'react-i18next';
import md5 from 'md5';
import { Field } from 'formik';
import fileUploaderIcon from '../static/icons/file2.png';
import photoUploaderIcon from '../static/icons/photo2.png';
import SignaturePad from '../shared/SignaturePad';
import FilePicker from './FilePicker';
import ImagePicker from './ImagePicker';
import { MobileView, TabletView } from 'react-device-detect';

const questionTypes = {
  TEXT: 0,
  RADIOBUTTON: 1,
  NUMBER: 2,
  CHECKBOX: 3,
  NONRESPONSE: 4,
  FILE_UPLOADER: 5,
  PHOTO_UPLOADER: 6,
  SIGNATURE: 7,
  DATE_PICKER: 8,
  DROP_DOWN: 9,
};

const GeneralQuestionnaire = (props) => {
  const { selectedVisitorType, filteredQuestions, pagination, isEnableIfThenQuestionnaire } = props;
  const { t } = useTranslation();
  if (selectedVisitorType === undefined) {
    return null;
  }

  if (filteredQuestions.length === 0) {
    return null;
  }
  const language = queryString.parse(window.location.search).language || 'en';

  if (pagination) {
    return (
      <div>
        {filteredQuestions.map((lq, index) => {
          if (!isEnableIfThenQuestionnaire) {
            const question = lq;
            if (index % 2 === 0) {
              let hashedLabelTwo, inputNameTwo, inputPropsTwo;
              const label = isString(get(question, 'label')) ? question.label : get(question, `label["en"]`) || 'q';
              const hashedLabel = md5(camelCase(label), {
                algorithm: 'md5',
              });

              const inputName = `question_inputN_${question.uuid || question.inputN}_${hashedLabel}`;

              const inputProps = {
                inputName,
                ...question,
                ...props,
                label,
              };

              let questionTwo = filteredQuestions[index + 1];
              if (questionTwo) {
                const label = isString(get(questionTwo, 'label')) ? questionTwo.label : get(questionTwo, `label["en"]`) || 'q2';
                hashedLabelTwo = md5(camelCase(label), {
                  algorithm: 'md5',
                });

                inputNameTwo = `question_inputN_${questionTwo.inputN}_${hashedLabelTwo}`;

                inputPropsTwo = {
                  inputNameTwo,
                  ...questionTwo,
                  ...props,
                  label,
                };
              }

              return (
                <div id={3 + Math.round(index / 2)} className={'questionPart'} key={index}>
                  <p className="text-lg text-black font-bold text-center">{t('Questionnaire')}</p>
                  <p className="text-black mt-1 mb-2 text-xs italic">{t('Please answer the questionnaire below')}:</p>
                  <hr className="mt-2 mb-2" />
                  <GeneralQuestionnaire.Input key={inputName} {...inputProps} />
                  <GeneralQuestionnaire.Input key={inputNameTwo} {...inputPropsTwo} />
                </div>
              );
            }
            return '';
          }
          //one by one question
          const question = lq.question;
          const label = isString(get(question, 'label')) ? question.label : get(question, `label["en"]`) || 'q';
          const hashedLabel = md5(camelCase(label), {
            algorithm: 'md5',
          });

          const inputName = `question_inputN_${question.uuid || question.inputN}_${hashedLabel}`;

          const inputProps = {
            inputName,
            ...question,
            ...props,
            label,
          };

          return (
            <div id={3 + Math.round(index / 2)} className={'questionPart'} key={index}>
              <p className="text-lg text-black font-bold text-center">{t('Questionnaire')}</p>
              <p className="text-black mt-1 mb-2 text-xs italic">{t('Please answer the questionnaire below')}:</p>
              <hr className="mt-2 mb-2" />
              <GeneralQuestionnaire.Input key={inputName} {...inputProps} />
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div id={3} className={'questionPart'}>
      <p className="mt-4 mb-4 text-3xl text-black font-bold text-center">{t('Questionnaire')}</p>
      <p className="text-black mt-1 mb-2 text-lg italic text-center">{t('Please answer the questionnaire below')}:</p>
      <hr className="mt-2 mb-2" />
      {filteredQuestions.map((questionf) => {
        const englishFallbackLabel = get(questionf, `label[en]`) || '';
        const label = isString(get(questionf, 'label')) ? questionf.label : get(questionf, `label[${language}]`) || englishFallbackLabel;
        const hashedLabelf = md5(camelCase(label || ''), {
          algorithm: 'md5',
        });
        const inputNamef = `question_inputN_${questionf.inputN}_${hashedLabelf}`;
        const inputPropsf = {
          inputNamef,
          ...questionf,
          ...props,
          label,
        };
        return <GeneralQuestionnaire.Input key={inputNamef} {...inputPropsf} />;
      })}
    </div>
  );
};

GeneralQuestionnaire.Input = (props) => {
  const { type, inputName, label, onChange, values, errors } = props;
  if (type === questionTypes.TEXT) {
    return (
      <div className="mb-4 text-black">
        <label className="block text-black mb-2" htmlFor={inputName}>
          {label}
        </label>
        <Field
          className={`shadow appearance-none text-black border rounded w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
            errors[inputName] ? 'border-red-500' : ''
          }`}
          id={inputName}
          name={inputName}
          type="text"
          placeholder={props.placeholder}
          onChange={props.onChange}
          value={props.values[props.inputName]}
          autoComplete="off"
        />
        {errors[inputName] ? <p className="text-gray-300 text-xl italic">{errors[inputName]}</p> : null}
      </div>
    );
  }
  if (type === questionTypes.RADIOBUTTON) {
    const onRadioButtonChange = (e, name, state) => {
      let event = { target: { name: name, value: state } };
      onChange(event);
    };
    return (
      <div className="mb-4 text-black">
        <p className="">{label}</p>
        <div className="px-4 py-2">
          <fieldset className="YesNoRadioButtons">
            <div className="radioButton">
              <input
                className={`mr-1 w-6 h-6 ${props.errors[props.inputName] ? 'border-red-500' : ''}`}
                type="radio"
                id={'Y' + props.inputName}
                name={props.inputName}
                onChange={(e) => onRadioButtonChange(e, props.inputName, true)}
              />
              <label htmlFor={'Y' + props.inputName}>
                <Trans>Yes</Trans>
              </label>
            </div>
            <div className="radioButton">
              <input
                className="mr-1 w-6 h-6"
                type="radio"
                id={'N' + props.inputName}
                name={props.inputName}
                onChange={(e) => onRadioButtonChange(e, props.inputName, false)}
              />
              <label htmlFor={'N' + props.inputName}>
                <Trans>No</Trans>
              </label>
            </div>
          </fieldset>
          {errors[inputName] ? <p className="text-gray-300 text-xl italic">{errors[inputName]}</p> : null}
        </div>
      </div>
    );
  }

  if (type === questionTypes.CHECKBOX) {
    return (
      <div className="mb-4 text-black">
        <p>{label}</p>
        <div className="px-4 py-2">
          <fieldset>
            <input className="mr-2 text-lg rounded" type="checkbox" id={inputName} name={inputName} onChange={onChange} value={values[inputName]} />
            <label htmlFor={inputName}>
              <Trans>Yes</Trans>
            </label>
          </fieldset>
          {errors[inputName] ? <p className="text-red-500 text-lg italic">{errors[inputName]}</p> : null}
        </div>
      </div>
    );
  }

  if (type === questionTypes.NUMBER) {
    return (
      <div className="mb-4 text-black">
        <label className="block mb-2" htmlFor={inputName}>
          {label}
        </label>
        <input
          className={`shadow appearance-none text-black border rounded w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
            errors[inputName] ? 'border-red-500' : ''
          }`}
          id={inputName}
          name={inputName}
          type="number"
          step="0.1"
          placeholder={props.placeholder}
          onChange={props.onChange}
          value={props.values[props.inputName]}
          autoComplete="off"
        />
        {errors[inputName] ? <p className="text-gray-300 text-xl italic">{errors[inputName]}</p> : null}
      </div>
    );
  }

  if (type === questionTypes.NONRESPONSE) {
    return (
      <div className="mb-4 text-black">
        <p>{label}</p>
      </div>
    );
  }

  if (type === questionTypes.FILE_UPLOADER) {
    return (
      <div className="mb-4 text-black uploader">
        <p>{label}</p>
        {props.placeholder && <span className="subheading">{props.placeholder}</span>}
        <div className="py-2">
          <fieldset>
            <FilePicker type={'FILE'} {...props}>
              <div
                style={{
                  backgroundColor: '#4379BC',
                  color: '#fff',
                  borderRadius: '20px',
                  padding: '10px 20px',
                  textAlign: 'center',
                  cursor: 'pointer',
                }}
              >
                Click to Take a picture or Upload a photo
              </div>
              {/* <img className="object-scale-down h-12 cursor" src={fileUploaderIcon} alt="FileUploader" /> */}
            </FilePicker>
            <span className="text-black">Click on file Icon to upload</span>
          </fieldset>
          {errors[inputName] ? <p className="text-red-500 text-lg italic">{errors[inputName]}</p> : null}
        </div>
        <p style={{ fontWeight: 'bold' }}>Accepted file format: .jpeg, .gif, .svg, .png, .webp</p>
        <br />
        <b style={{ color: 'red', fontWeight: 'bold' }}>PDF files are not accepted.</b>
        <br />
        <br />
        <p style={{ fontWeight: 'bold' }}>
          For more information, watch this video:{' '}
          <a target="_blank" href="https://youtu.be/6BafBJGjeqg" style={{ textDecoration: 'none', color: '#03A9F4' }}>
            https://youtu.be/6BafBJGjeqg
          </a>
        </p>
      </div>
    );
  }
  if (type === questionTypes.PHOTO_UPLOADER) {
    return (
      <div className="mb-4 text-black uploader">
        <p className="text-black">{label}</p>
        {props.placeholder && <span className="subheading text-black">{props.placeholder}</span>}
        <div className="py-2">
          <fieldset>
            <ImagePicker {...props}>
              <div
                style={{
                  backgroundColor: '#4379BC',
                  color: '#fff',
                  borderRadius: '20px',
                  padding: '10px 20px',
                  textAlign: 'center',
                  cursor: 'pointer',
                }}
              >
                Click to Take a picture or Upload a photo
              </div>
              {/* <img className="object-scale-down h-12 cursor 1623087376071 text-black" src={photoUploaderIcon} alt="ImageUploader" style={{ tintColor: 'black' }} /> */}
            </ImagePicker>
          </fieldset>
          {errors[inputName] ? <p className="text-red-500 text-lg italic">{errors[inputName]}</p> : null}
        </div>
        <p style={{ fontWeight: 'bold' }}>Accepted file format: .jpeg, .gif, .svg, .png, .webp</p>
        <br />
        <b style={{ color: 'red', fontWeight: 'bold' }}>PDF files are not accepted.</b>
        <br />
        <br />
        <p style={{ fontWeight: 'bold' }}>
          For more information, watch this video:{' '}
          <a target="_blank" href="https://youtu.be/6BafBJGjeqg" style={{ textDecoration: 'none', color: '#03A9F4' }}>
            https://youtu.be/6BafBJGjeqg
          </a>
        </p>
      </div>
    );
  }

  if (type === questionTypes.DATE_PICKER) {
    return (
      <div className="mb-4 text-black uploader">
        <p>{label}</p>
        {props.placeholder && <span className="subheading text-black">{props.placeholder}</span>}
        <div className="py-2">
          <fieldset>
            <legend className="font-black mb-4">From</legend>
            <MobileView>
              <h4>Select by clicking on below field</h4>
            </MobileView>
            <TabletView>
              <h4>Select by clicking on below field</h4>
            </TabletView>
            <input
              className={`shadow appearance-none text-black border rounded w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors[inputName] ? 'border-red-500' : ''
              }`}
              id={inputName}
              name={inputName}
              type="date"
              onChange={(event) => props.setFieldValue(`${inputName}.from`, event.target.value)}
              defaultValue={props.values[props.inputName]}
              autoComplete="off"
            />
          </fieldset>
          {errors[inputName] ? <p className="text-red-500 text-lg italic">{errors[inputName]}</p> : null}
          <fieldset>
            <legend className="font-black mb-4">To</legend>
            <MobileView>
              <h4>Select by clicking on below field</h4>
            </MobileView>
            <TabletView>
              <h4>Select by clicking on below field</h4>
            </TabletView>
            <input
              className={`shadow appearance-none text-black border rounded w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors[props.inputNameTo] ? 'border-red-500' : ''
              }`}
              id={`${inputName}.to`}
              name={`${inputName}.to`}
              type="date"
              onChange={(event) => props.setFieldValue(`${inputName}.to`, event.target.value)}
              defaultValue={props.values[props.inputNameTo]}
              autoComplete="off"
            />
          </fieldset>
          {errors[props.inputNameTo] ? <p className="text-red-500 text-lg italic">{errors[props.inputNameTo]}</p> : null}
        </div>
      </div>
    );
  }

  if (type === questionTypes.DROP_DOWN) {
    return (
      <div className="mb-4 text-black">
        <label className="block mb-2 text-black" htmlFor={inputName}>
          {label}
        </label>
        <select
          id={inputName}
          name={inputName}
          className={`bg-white shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
            errors[inputName] ? 'border-red-500' : ''
          }`}
          onChange={onChange}
          defaultValue={''}
          // onBlur={handleBlur}
        >
          <option disabled={true} value="">
            {props?.placeholder}
          </option>
          {props.dropDownItems.map((purpose, index) => (
            <option key={index} id={index} value={purpose.value}>
              {purpose.value}
            </option>
          ))}
        </select>
        {errors[inputName] ? <p className="text-gray-300 text-xl italic">{errors[inputName]}</p> : null}
      </div>
    );
  }

  if (type === questionTypes.SIGNATURE) {
    return <SignaturePad {...props} />;
  }

  return null;
};

// export default GeneralQuestionnaire;
export { questionTypes, GeneralQuestionnaire };
